var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsErrorIc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.901 0H4.1L0 4.099V9.9L4.099 14H9.9L14 9.901V4.1L9.901 0zM7 11c-.554 0-1-.446-1-1s.446-1 1-1 1 .446 1 1-.446 1-1 1zm1-3H6V3h2v5z",
    transform: "translate(-209 -329) translate(158 193) translate(0 128) translate(51 8)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsErrorIc);
export default __webpack_public_path__ + "static/media/icons-error-ic.12ce25c959a0f54c37fccdcaf37ab3b5.svg";
export { ForwardRef as ReactComponent };